import React, { FC } from 'react';
import { goBack } from 'connected-react-router';

import { useAction } from 'Modules/core/redux';
import { ExternalLeft24, IconButton } from 'Modules/ui3';


export const BackButton: FC = () => {
    const back = useAction(goBack);
    return (
        <IconButton variant='secondary' size='large' isRound onClick={back}>
            <ExternalLeft24 />
        </IconButton>
    );
};
